import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { setFastLaneTesting } from '../../frameworks_drivers/redux/reducers/abTest/abTestingSlice';
import { FastLaneTestingState } from '../../entities/model/redux/FastLaneTestingState';

export const useFastLane = () => {
  const fastLane = useSelector((state: RootState) => state.abTesting.fastLaneTesting);
  const dispatch = useDispatch();

  const setFastLane = (fastLane: string) => {
    dispatch(
      setFastLaneTesting({
        fastLaneEnabled: fastLane,
        experimentId: 'fastLane'
      } as FastLaneTestingState)
    );
  };

  return {
    fastLane,
    setFastLane
  };
};
